import type IUsersRepository from '@/core/domain/users/IUsersRepository.ts'

export default class ResetPasswordUserUseCase {
  private readonly userRepository: IUsersRepository

  constructor(userRepository: IUsersRepository) {
    this.userRepository = userRepository
  }

  async execute(identifier: string): Promise<string> {
    return await this.userRepository.resetPassword(identifier)
  }
}